/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { Stack, FormControl, FormErrorMessage } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormLabelInput from '../formInputs/FormLabelInput';
import FormTextInput from '../formInputs/FormTextInput';
import { useUpdateFormItem } from '../hooks/useUpdateFormItem';
import { useGetItemProperty } from '../hooks/useGetItemProperty';
import { FormBuilderComponentProps } from '../types';
import { useStoreState } from '../../../../models/hooks';
import useHireFormErrorHandling, { ValidationType, ValidationTypeEnum } from '../hooks/useHireFormErrorHandling';
import TextField from '../formInputs/TextField';

function LinkFieldComponent({ fieldId, isAdvanced }: Omit<FormBuilderComponentProps, 'path'>) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <FormLabelInput fieldId={fieldId} isAdvanced={isAdvanced} />
      <FormTextInput fieldId={fieldId} placeholder={t('formBuilder.editorPlaceholder.link')} isAdvanced={isAdvanced || false} />
      <LinkInput fieldId={fieldId} />
    </Stack>
  );
}

function LinkInput({ fieldId, isAdvanced }: Pick<FormBuilderComponentProps, 'fieldId' | 'isAdvanced'>) {
  const language = useStoreState((state) => state.formBuilder.currentLanguage);

  const currentFieldValue = useGetItemProperty(fieldId, 'link'); // Uses renamed prop
  const handleOnChange = useUpdateFormItem();

  const { validate, error, hasError, inputRef } = useHireFormErrorHandling({
    targetId: fieldId,
    innerPath: `link.${language}`,
    validationType: ValidationTypeEnum.LINK as ValidationType,
    isAdvanced: isAdvanced || false,
  });

  const [value, setValue] = React.useState(currentFieldValue ?? '');

  React.useEffect(() => {
    setValue(currentFieldValue ?? '');
  }, [currentFieldValue, language]);

  const handleBlur = () => {
    handleOnChange(fieldId, { link: { ...currentFieldValue, [language]: value } });
  };

  const handleChange = (val: string) => {
    setValue(val);

    validate(val);
  };
  return (
    <FormControl isInvalid={hasError}>
      <TextField
        ref={inputRef}
        type="url"
        placeholder="Paste your link here"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {hasError && (
        <FormErrorMessage mt={0} fontSize="xs">
          {error}
        </FormErrorMessage>
      )}
    </FormControl>
  );
}

export const LinkField = React.memo(
  LinkFieldComponent,
  (prev, next) =>
    /* eslint-disable-next-line  */
    prev.fieldId === next.fieldId && prev.isAdvanced === next.isAdvanced && prev.labelRightRenderer === next.labelRightRenderer,
);
